import { Box, BoxProps, Drawer, DrawerCloseButton, DrawerContent, DrawerOverlay, Flex, IconButton, Spacer, Stack, Text, useDisclosure, theme } from '@chakra-ui/react';
import { FC, ReactElement } from 'react';
import { ICON_BY_NAME } from 'ui/components/Icons/Icon';
import { CbLeftMenuItem } from '../CbLeftMenuItem';
import { CbProfileWidget } from '../CbProfileWidget';
import { MenuLinks } from '../../types/MenuLinks';
import { SideMenuProfile } from '../../types/SideMenuProfile';
export interface CbLeftMenuProps extends BoxProps {
  menuLinks: MenuLinks[];
  logo?: ReactElement;
  profile?: SideMenuProfile;
  shouldDisplayOnMobile?: boolean;
}
export const CbLeftMenu: FC<CbLeftMenuProps> = ({
  menuLinks,
  logo,
  profile,
  shouldDisplayOnMobile,
  ...props
}) => {
  const {
    isOpen,
    onOpen,
    onClose
  } = useDisclosure();
  const handleClick = (clickHandler): any => {
    clickHandler();
    onClose();
  };
  const menu = <Flex height="100vh" position="fixed" zIndex={theme.zIndices.base} width={{
    base: 'full',
    sm: 'xs'
  }} direction="column" background="luigisPants.500" color="white" paddingX={4} paddingTop={8} paddingBottom={{
    base: 32,
    sm: 8
  }} overflowY="auto" css={{
    '&::-webkit-scrollbar': {
      width: '4px'
    },
    '&::-webkit-scrollbar-track': {
      width: '6px'
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: '24px'
    }
  }} {...props}>
      {logo && <Box marginBottom={6} marginLeft={2}>
          {logo}
        </Box>}
      <Stack spacing={6}>
        {menuLinks.map((link, index) => <Stack key={`stack-${index}`}>
            {link.title && <Text color="text.secondaryWhite" fontFamily="codenext" fontSize="sm" fontWeight="bold" marginLeft={1} marginTop={4}>
                {link.title}
              </Text>}
            {link.links?.map(link => <CbLeftMenuItem key={link.label} as={link.as} label={link.label} href={link.href} isExternal={link.isExternal} onClick={event => link.onClick != null ? handleClick(() => link.onClick?.(event)) : onClose()} leftIcon={link.leftIcon} rightIcon={link.rightIcon} notificationCount={link.notificationCount} isActive={link.isActive} />)}
          </Stack>)}
      </Stack>
      <Spacer />
      {profile && <Box position="sticky" bottom={shouldDisplayOnMobile ? '-164px' : '-69px'} marginTop={8}>
          <CbProfileWidget name={profile?.name} image={profile?.profileImage} href={profile?.href} as={profile?.as} notificationCount={profile?.notificationCount} onClick={event => profile?.onClick != null ? handleClick(() => profile?.onClick?.(event)) : onClose()} text={profile?.text} />
        </Box>}
    </Flex>;
  if (shouldDisplayOnMobile ?? false) {
    return <>
        <IconButton aria-label="Menu" backgroundColor="luigisPants.500" borderBottomRightRadius={8} color="white" onClick={isOpen ? onClose : onOpen} _focus={{
        outline: 'none !important'
      }} zIndex={theme.zIndices.docked} top={16} position={'fixed'}>
          <ICON_BY_NAME.menuwide />
        </IconButton>

        <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton color="white" zIndex={theme.zIndices.docked} _focus={{
            outline: 'none !important'
          }} />
            {menu}
          </DrawerContent>
        </Drawer>
      </>;
  }
  return menu;
};